import React from "react";
import { RefreshCw, Layers, Users } from "lucide-react";

const TeamsStats = ({
    totalTeams,
    totalUsersInTeams,
    totalActionsRequired = 0,
    isRefreshing,
    fetchData
}) => (
    <>
        <h2 id="quick-buttons" className="text-xl dark:text-white flex items-center justify-between mb-4">
            <span>Stats</span>
            <button
                onClick={() => fetchData(true)}
                disabled={isRefreshing}
                className={`text-sm font-medium flex items-center gap-2 px-3 py-1.5 rounded-lg
                    ${isRefreshing
                        ? 'bg-gray-100 text-gray-400 dark:bg-gray-800 dark:text-gray-500 cursor-not-allowed'
                        : 'bg-blue-50 text-blue-600 hover:bg-blue-100 dark:bg-blue-900/20 dark:text-blue-400 dark:hover:bg-blue-900/30 cursor-pointer'
                    } transition-colors duration-200`}
            >
                <RefreshCw className={`w-4 h-4 ${isRefreshing ? 'animate-spin' : ''}`} />
                {isRefreshing ? 'Refreshing...' : 'Refresh'}
            </button>
        </h2>
        <div className={`grid gap-4 w-full grid-cols-3`}>
            <div className="flex items-center rounded-xl bg-gradient-to-br from-orange-50 to-transparent dark:from-orange-900/10 dark:to-transparent hover:from-orange-100 dark:hover:from-orange-900/20 transition-colors duration-300 shadow-sm hover:shadow-md">
                <div className="w-full">
                    <div className="flex justify-center items-center p-2">
                        <Layers className="text-orange-600 w-8 h-8 mr-2" />
                        <p className="text-2xl pt-5 font-bold dark:text-white tracking-tight">{totalTeams}</p>
                    </div>
                    <p className="text-sm font-medium text-orange-600 dark:text-orange-400 text-center">Teams</p>
                </div>
            </div>
            <div className="flex items-center rounded-xl bg-gradient-to-br from-blue-50 to-transparent dark:from-blue-900/10 dark:to-transparent hover:from-blue-100 dark:hover:from-blue-900/20 transition-colors duration-300 shadow-sm hover:shadow-md">
                <div className="w-full">
                    <div className="flex justify-center items-center p-2">
                        <Users className="text-blue-600 w-8 h-8 mr-2" />
                        <p className="text-2xl pt-5 font-bold dark:text-white tracking-tight">{totalUsersInTeams}</p>
                    </div>
                    <p className="text-sm font-medium text-blue-600 dark:text-blue-400 text-center">Team Members</p>
                </div>
            </div>
            {/* Actions Required Card: Green if 0, Yellow if >0 */}
            <div className={`flex items-center rounded-xl transition-colors duration-300 shadow-sm hover:shadow-md 
                ${totalActionsRequired === 0
                    ? 'bg-gradient-to-br from-green-50 to-transparent dark:from-green-900/10 dark:to-transparent hover:from-green-100 dark:hover:from-green-900/20'
                    : 'bg-gradient-to-br from-yellow-50 to-transparent dark:from-yellow-900/10 dark:to-transparent hover:from-yellow-100 dark:hover:from-yellow-900/20'}
            `}>
                <div className="w-full">
                    <div className="flex justify-center items-center p-2">
                        <svg className={`${totalActionsRequired === 0 ? 'text-green-600' : 'text-yellow-600'} w-8 h-8 mr-2`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                            <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" fill="none" />
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01" />
                        </svg>
                        <p className="text-2xl pt-5 font-bold dark:text-white tracking-tight">{totalActionsRequired}</p>
                    </div>
                    <p className={`text-sm font-medium text-center ${totalActionsRequired === 0 ? 'text-green-600 dark:text-green-400' : 'text-yellow-600 dark:text-yellow-400'}`}>Actions Required</p>
                </div>
            </div>
        </div>
    </>
);

export default TeamsStats;
